import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ContextService, XenaClient } from 'src/app/services';
import { ISaveResult } from 'src/app/xena-api';

@Injectable({
  providedIn: 'root'
})
export class ElectronicInvoicingService {

  constructor(
    private xenaClient: XenaClient,
    protected context: ContextService
  ) { }

  postRegisterNemHandel(): Observable<ISaveResult> {
    const path: string = `/Fiscal/${this.context.fiscalId}/ElectronicInvoicing/Sproom/Registration/Nemhandel`;
    return this.xenaClient.post<void, ISaveResult>(path, null);
  }
}
